import React, { useState, useEffect } from "react";
import { fetchTeacherById, updateTeacherImage, fetchImag } from "../../../ApiController/teacherApi";
import { FiCamera } from "react-icons/fi";
import DefaultProfileImage from "../../../../Images/default-profile.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import "./UserPage.css";

const TeacherInfo = ({dataChanged}) => {
  const [teacher, setTeacher] = useState({ id: "", firstName: "", lastName: "" });
  const [teacherImage, setTeacherImage] = useState(DefaultProfileImage);
  useEffect(() => {
    const fetchTeacherData = async () => {
      try {
        const userId = sessionStorage.getItem("userId");
        if (!userId) {
          throw new Error("Inget användar-ID hittades i sessionen.");
        }
        
        let teacherData;
        let teacherImg;
        if (!sessionStorage.getItem("teacherInfo")) {
          console.log("hallo")
          teacherData = await fetchTeacherById(userId);
          teacherImg = teacherData.imgdata;
          sessionStorage.setItem("teacherInfo", JSON.stringify(teacherData));
          sessionStorage.setItem("teacherImg", JSON.stringify(teacherData.imgdata));
        } else {
          teacherData = JSON.parse(sessionStorage.getItem("teacherInfo"));
          teacherImg = JSON.parse(sessionStorage.getItem("teacherImg"));
        }
  
        setTeacher({
          id: teacherData.id,
          firstName: teacherData.firstName,
          lastName: teacherData.lastName,
        });
        setTeacherImage(teacherImg);
      } catch (error) {
        console.error("Fel vid hämtning av lärare:", error);
      }
    };
  
    fetchTeacherData();
  }, []); 

  const handleImageChange = async (e, id) => {
    if (e.target.files && e.target.files[0]) {
      try {
        await updateTeacherImage(id, e.target.files[0]);
        alert("Bilden uppdaterades!");

        const newImage = await fetchImag(id);
        setTeacherImage(newImage.imgdata);
        sessionStorage.setItem("teacherImg", JSON.stringify(newImage.imgdata));
      } catch (error) {
        console.error("Error:", error);
        alert(error.response?.data?.error || "Det gick inte att uppdatera bilden.");
      }
    }
  };

  const handleImageError = (e) => {
    e.target.src = DefaultProfileImage;
  };

  return (
    <div className="container ">
      <form className="mb-3">
        <div className="container mt-1">
          <div className="d-flex flex-row flex-wrap justify-content-center align-items-center teacher-info">
            <div className="card mb-1 me-1 custom-card">
              <div className="card-body">
                <div className="mb-2">
                  <img
                    src={teacherImage}
                    alt="Profile"
                    className="img-thumbnail"
                    onError={handleImageError}
                  />

                  <label htmlFor="image-upload" className="d-block label-flex">
                    <FiCamera size={20} className="camera-icon mt-1" />
                  </label>
                  <input
                    type="file"
                    id="image-upload"
                    hidden
                    onChange={(e) => handleImageChange(e, teacher.id)}
                    accept="image/*"
                  />
                </div>
                {["id", "firstName", "lastName"].map((field) => (
                  <div key={field} className="mb-2">
                    <label htmlFor={field} className="form-label">
                      {field === "id" ? "ID" : field === "firstName" ? "Förnamn" : "Efternamn"}
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id={field}
                      name={field}
                      value={teacher[field]}
                      readOnly
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default TeacherInfo;
